import OpenReplay from "@openreplay/tracker";
import { BASE_API, IS_PROD, PRODUCTION_BASE_API } from "./constants";

const productKey = () => {
  if (BASE_API.includes(PRODUCTION_BASE_API)) {
    return import.meta.env.VITE_OPEN_REPLAY_KEY;
  } else {
    return import.meta.env.VITE_STAGING_OPEN_REPLAY_KEY;
  }
};

const openReplay = new OpenReplay({
  projectKey: productKey(),
  ingestPoint: "https://openreplay.pressone.co/ingest",
  network: {
    capturePayload: true, // Capture HTTP payload
    ignoreHeaders: false,
    captureInIframes: true,
    sessionTokenHeader: false,
    failuresOnly: false,
  },
  __DISABLE_SECURE_MODE: !IS_PROD,
});

export default openReplay;
